import React from 'react'
import { observer } from 'mobx-react'
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import * as defaultConst from '../../../constants/default_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../../input/date'
import EmbededEntityInput from '../../input/embedded_entity'
import HelpOverlay from '../../utils/helpOverlay'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../../input/select'
import TextArea from '../../input/textArea'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import moment from 'moment'

const PaymentsEdit = ({ store, ...rest }) => {
  const _PaymentsEditForm = observer(({ store, record, updateFormField, errors }) => {
    const isID = record.has('id') && record.get('id')
    const amountToBePaid = record.has('amount_to_be_paid') ? parseFloat(record.get('amount_to_be_paid') || 0) : 0
    const wireFee = record.has('wire_fee') ? parseFloat(record.get('wire_fee') || 0) : 0
    const withholdingTax = record.has('withholding_tax_amount') ? parseFloat(record.get('withholding_tax_amount') || 0) : 0
    const amountPaid = record.has('amount_paid') ? parseFloat(record.get('amount_paid') || 0) : 0
    const isAmountPaid = record.has('amount_paid') && record.get('amount_paid') !== null &&
      record.get('amount_paid') !== '' && record.get('amount_paid').toString().length > 0
    const revenuesCalculatedBool = parseFloat(amountPaid + wireFee + withholdingTax)
      .toFixed(2) !== parseFloat(amountToBePaid).toFixed(2)

    const contractors = ((store.cv.record.has('contractors_from_shares') && store.cv.record.get('contractors_from_shares')) || [])
      .concat((store.cv.record.has('shares') && store.cv.record.get('shares')) || [])
    const contractorsFiltred = contractors
      .filter(i => contractors.length > 1 ? !(defaultConst.BLUESKY_CONTRACTOR_IDS).includes(i.contractor_id) : true)
      .map(i => parseInt(i.contractor_id))
    const contractorSelected = record.has('contractor_id') && record.get('contractor_id') &&
      store.options.get('clients').find(i => i.id === record.get('contractor_id'))
    const contractorSelectedTax = contractorSelected && contractorSelected.withholding_tax && contractorSelected.withholding_tax > 0
      ? parseFloat(contractorSelected.withholding_tax).toFixed(6)
      : parseFloat(0).toFixed(6)
    const contractorTaxCalculated = amountToBePaid > 0
      ? (parseFloat(contractorSelectedTax) / 100 * parseFloat(amountToBePaid)).toFixed(2)
      : 0
    const contractorSelectedVat = contractorSelected && contractorSelected.vat_rate && contractorSelected.vat_rate > 0
      ? parseFloat(contractorSelected.vat_rate).toFixed(6)
      : parseFloat(0).toFixed(6)
    const contractorVatCalculated = amountPaid > 0
      ? (parseFloat(contractorSelectedVat) / 100 * parseFloat(amountPaid)).toFixed(2)
      : 0

    const vatRate = !record.has('vat_amount')
      ? contractorVatCalculated
      : parseFloat(record.get('vat_amount') || 0)
    const warningAmountPayable = revenuesCalculatedBool && isAmountPaid
    const warningWithholdingTax = amountToBePaid > 0 && (contractorSelectedTax > 0 || (withholdingTax && withholdingTax > 0)) &&
      parseFloat(contractorTaxCalculated).toFixed(2) !== parseFloat(withholdingTax).toFixed(2)
    const warningVatRate = amountToBePaid > 0 && (contractorSelectedVat > 0 || (vatRate && vatRate > 0)) &&
      parseFloat(contractorVatCalculated).toFixed(2) !== parseFloat(vatRate).toFixed(2)

    const paymentLimit = store.cv.record && store.cv.record.has('payment_minimum_limit') && store.cv.record.get('payment_minimum_limit')
    const paymentWireFee = store.cv.record && store.cv.record.has('payment_wire_fee') && store.cv.record.get('payment_wire_fee')
    const warningPaymentLimit = amountToBePaid > 0 && paymentLimit && paymentLimit > 0 && paymentLimit > amountToBePaid
    const payDate = record.has('pay_date') && record.get('pay_date') &&
      moment(record.get('pay_date')).isValid() && moment(record.get('pay_date'))
    const timeoutDisabled = store.cv.timeoutDisabled

    const updateField = (attr) => {
      store.cv.timeoutDisabled = true
      setTimeout(_ => { store.cv.timeoutDisabled = false }, 1500) // lock button
      let wireFeeNew = null

      if (attr === 'all' && (!record.has('wire_fee') || !record.get('wire_fee'))) {
        wireFeeNew = parseFloat(paymentWireFee || 0)
        updateFormField('wire_fee', wireFeeNew.toFixed(2))
      }
      if (attr === 'withholding_tax_amount' || attr === 'all') {
        updateFormField('withholding_tax_amount', parseFloat(contractorTaxCalculated || 0).toFixed(2))
        store.addMessage(store.__('Withholding tax recalculated'), 'info')
      }
      if (attr !== 'withholding_tax_amount' || attr === 'all') {
        if (attr === 'vat_amount' || attr === 'all') {
          updateFormField('vat_amount', parseFloat(contractorVatCalculated).toFixed(2))
          store.addMessage(store.__('VAT rate recalculated'), 'info')
          if (attr === 'vat_amount') {
            return
          }
        } else {
          store.addMessage(amountPaid && amountPaid > 0
            ? store.__('Transfer amount recalculated')
            : store.__('Transfer amount calculated'), 'info')
        }
        const thisWithholdingTax = record.has('withholding_tax_amount') ? parseFloat(record.get('withholding_tax_amount') || 0) : 0
        const newAmountPaid = parseFloat(amountToBePaid - (wireFeeNew !== null ? wireFeeNew : wireFee) - thisWithholdingTax)
        const thisVatRate = attr === 'vat_amount'
          ? parseFloat(contractorVatCalculated).toFixed(2)
          : ((!record.has('vat_amount') || !record.get('vat_amount') || attr === 'all')
            ? (newAmountPaid > 0
              ? (parseFloat(contractorSelectedVat) / 100 * parseFloat(newAmountPaid)).toFixed(2)
              : (0).toFixed(2))
            : vatRate)
        const newAmountPaidWithVat = parseFloat(newAmountPaid) + parseFloat(thisVatRate)

        updateFormField('amount_paid', parseFloat(newAmountPaid > 0 ? newAmountPaid : 0).toFixed(2))
        updateFormField('amount_paid_including_vat', parseFloat(newAmountPaid > 0 ? newAmountPaidWithVat : 0).toFixed(2))
        updateFormField('vat_amount', parseFloat(thisVatRate).toFixed(2))

        if (!record.has('status') || !record.get('status') || ['new', 'in_processing', 'postponed', '', null].includes(record.get('status'))) {
          const newStatus = payDate
            ? (payDate.isAfter(moment(), 'day') ? 'waiting' : 'paid')
            : 'in_processing'
          updateFormField('status', newStatus)
        }
        if (attr === 'all') {
          store.addMessage(store.__('Transfer amount recalculated'), 'info')
        }
      }
    }

    return (
      <div className='row'>
        <div className='col-xs-12'>
          <SelectInput label={store.__('contractor')} attr={'contractor_id'} record={record}
            onChange={updateFormField} labelattr='name' valueattr='id'
            valueFilterFc={i => contractorsFiltred ? ![...contractorsFiltred].includes(parseInt(i.id)) : true}
            optionsrecord={store.options} optionsattr={'clients'} errors={errors} />
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <SelectInput
                disabled={true}
                label={store.__('contract currency')}
                attr={'currency'}
                record={store.cv.record}
                labelattr='text'
                valueattr='value'
                optionsrecord={store.options}
                optionsattr={'ContractCurrency'}
                errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <TextInput
                disabled={true} type='number'
                label={store.__('payment minimum limit')}
                attr={'payment_minimum_limit'}
                record={store.cv.record}
                errors={errors} />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-3'>
              <TextInput type='number' step='1' min='1' max='12'
                label={store.__('month (period)')} attr={'month'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-3'>
              <TextInput type='number' step='1' min='1900' max='2100'
                label={store.__('year')} attr={'year'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-3'>
              <SelectInput label={store.__('status')} attr={'status'} record={record}
                onChange={updateFormField} optionsrecord={store.options}
                optionsattr={'ContractPaymentsStatus'} labelattr='text' errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-3'>
              <label>{store.__('Recalculate')}</label><br />
              <p>
                <Button bsSize='medium'
                  bsStyle={warningAmountPayable || warningWithholdingTax || warningVatRate
                    ? 'success'
                    : 'default'}
                  onClick={_ => updateField('all')} disabled={timeoutDisabled}>
                  <em className='glyphicon glyphicon-refresh'></em> &nbsp;
                  {amountPaid && amountPaid > 0
                    ? store.__('Recalculate ALL values')
                    : store.__('Calculate ALL values')}
                </Button>
                <HelpOverlay store={store} path='contracts/contract_payments/recalculate_all_button' />
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <TextInput type='number' step='0.01' label={store.__('amount payable')} attr={'amount_to_be_paid'}
                record={record} onChange={updateFormField} errors={errors} disabled={isID} />
              {warningPaymentLimit
                ? <p className='text-warning input-with-warning'>
                  {store.__('Warning: "Amount payable" value is less than the "Payment minimum limit".')}
                </p>
                : ''}
            </div>
            <div className={'col-xs-12 col-lg-6' + (warningAmountPayable ? ' has-warning ' : '')}>
              <TextInput type='number' attrValue={isAmountPaid
                ? parseFloat(amountPaid + wireFee + withholdingTax).toFixed(2).toString()
                : ' '}
              label={<strong>{
                store.__('amount payable calculated')}&nbsp;
              <HelpOverlay store={store} path='contracts/contract_payments/amount_to_be_paid_calculated' /></strong>}
              disabled={true} />
              {warningAmountPayable
                ? <div>
                  {parseFloat(amountPaid + wireFee + withholdingTax).toFixed(2) > amountToBePaid
                    ? <p className='text-warning input-with-warning'>{store.__('Warning: "Amount payable" value is less than the calculated value.')}</p>
                    : <p className='text-warning input-with-warning'>{store.__('Warning: "Amount payable" value does not match the calculated value.')}</p>}
                </div>
                : ''}
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <TextInput type='number' step='0.01' label={store.__('wire fee')} attr={'wire_fee'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <div className='row'>
                <div className={'col-xs-6 col-lg-6' + (warningWithholdingTax ? ' has-warning ' : '')}>
                  <TextInput type='number' step='0.01' label={store.__('withholding tax (amount)')} attr={'withholding_tax_amount'}
                    record={record} onChange={updateFormField} errors={errors} />
                </div>
                <div className='col-xs-6 col-lg-6'>
                  <TextInput type='number' label={store.__('withholding tax (%)')}
                    attrValue={parseFloat(contractorSelectedTax).toFixed(6).toString()}
                    record={record} disabled={true} errors={errors} />
                </div>
                {warningWithholdingTax
                  ? <div className='col-xs-12'>
                    <p className='text-warning input-with-warning'>
                      {withholdingTax && withholdingTax >= 0
                        ? store.__('Warning: Inserted amount does not match the calculated amount').concat(' ') +
                        contractorTaxCalculated
                        : store.__('Warning: Withholding tax is missing. The calculated amount is').concat(' ') +
                        contractorTaxCalculated}. &nbsp;
                      <Button bsSize='xs' bsStyle='default' onClick={_ => updateField('withholding_tax_amount')} disabled={timeoutDisabled}>
                        <em className='glyphicon glyphicon-refresh'></em> {store.__('Fix')}
                      </Button>
                    </p>
                  </div>
                  : ''}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <DateInput label={store.__('pay date')} attr={'pay_date'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <TextInput type='text' label={store.__('invoice number')} attr={'invoice_number'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <TextInput type='number' step='0.01' label={store.__('transfer amount')} attr={'amount_paid'}
                record={record} onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <label>{store.__('Recalculate')}</label><br />
              <p>
                <Button bsSize='medium' bsStyle='default' onClick={_ => updateField('amount_paid')} disabled={timeoutDisabled}>
                  <em className='glyphicon glyphicon-refresh'></em> &nbsp;
                  {amountPaid && amountPaid > 0
                    ? store.__('Recalculate "Transfer amount" only')
                    : store.__('Calculate "Transfer amount" only')}
                </Button>
                <HelpOverlay store={store} path='contracts/contract_payments/recalculate_amount_paid_button' />
              </p>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <TextInput type='number' step='0.01' label={store.__('transfer amount (including VAT)')} attr={'amount_paid_including_vat'}
                record={record} onChange={updateFormField} errors={errors} disabled />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <div className='row'>
                <div className={'col-xs-6 col-lg-6' + (warningVatRate ? ' has-warning ' : '')}>
                  <TextInput type='number' step='0.01' label={store.__('VAT (amount)')} attr={'vat_amount'}
                    record={record} onChange={updateFormField} errors={errors} />
                </div>
                <div className='col-xs-6 col-lg-6'>
                  <TextInput type='number' label={store.__('VAT (%)')}
                    attrValue={parseFloat(contractorSelectedVat).toFixed(6).toString()}
                    record={record} disabled={true} errors={errors} />
                </div>
                {warningVatRate
                  ? <div className='col-xs-12'>
                    <p className='text-warning input-with-warning'>
                      {vatRate && vatRate >= 0
                        ? store.__('Warning: Inserted amount does not match the calculated amount').concat(' ') +
                        contractorVatCalculated
                        : store.__('Warning: VAT (amount) is missing. The calculated amount is').concat(' ') +
                        contractorVatCalculated}. &nbsp;
                      <Button bsSize='xs' bsStyle='default' onClick={_ => updateField('vat_amount')} disabled={timeoutDisabled}>
                        <em className='glyphicon glyphicon-refresh'></em> {store.__('Fix')}
                      </Button>
                    </p>
                  </div>
                  : ''}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-lg-6'>
              <TextArea label={store.__('internal note')} attr={'note'} record={record} rows={2}
                onChange={updateFormField} errors={errors} />
            </div>
            <div className='col-xs-12 col-lg-6'>
              <TextArea label={store.__('client note')} attr={'note_client'} record={record} rows={2}
                onChange={updateFormField} errors={errors} />
            </div>
          </div>
          {record.has('dwh_last_updated_at') && record.get('dwh_last_updated_at') &&
            <DateInput label={store.__('DWH last update')} attr={'dwh_last_updated_at'} showTime={true}
              record={record} onChange={updateFormField} errors={errors} disabled={true} />}
          {record.has('bi_changelog') && record.get('bi_changelog') &&
            <TextArea label={store.__('BI changelog')} attr={'bi_changelog'} rows={5}
              record={record} errors={errors} disabled={true} />}
        </div>
      </div>
    )
  })

  const _taxValuesHelper = (store, row, tax) => {
    const withholdingTax = tax && tax > 0
      ? parseFloat(tax)
      : 0
    const amountToBePaid = row.amount_to_be_paid || 0
    const contractorSelected = row.contractor_id && store.options.get('clients').find(i => i.id === row.contractor_id)
    const contractorSelectedTax = contractorSelected && contractorSelected.withholding_tax && contractorSelected.withholding_tax > 0
      ? parseFloat(contractorSelected.withholding_tax).toFixed(6)
      : parseFloat(0).toFixed(6)
    const contractorTaxCalculated = amountToBePaid > 0
      ? (parseFloat(contractorSelectedTax) / 100 * parseFloat(amountToBePaid)).toFixed(2)
      : 0
    const warningWithholdingTax = amountToBePaid > 0 && parseFloat(contractorTaxCalculated).toFixed(2) !== withholdingTax.toFixed(2)
    return { withholdingTax, warningWithholdingTax, contractorTaxCalculated }
  }

  const constantsAbsRec = store.options.has('constantsList') &&
    store.options.get('constantsList') &&
    store.options.get('constantsList').find(i => i.id === 'PAYMENTS_ROUNDING_NO_WARNING')
  const constantsAbsVal = constantsAbsRec && constantsAbsRec.List_code ? parseFloat(constantsAbsRec.List_code) : 0

  return (
    <EmbededEntityInput {...rest}
      store={store}
      edit_title={store.__('edit payments')}
      add_title={store.__('add payments')}
      attr={'contract_payments'}
      errors={store.cv.errors}
      addFilter={{ key: 'status', values: ['postponed', 'canceled'] }}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => {
          const DetailLink = ({ text }) => (
            <a href='javascript:void(0)'
              onClick={() => store.goTo('entity_detail', { entityname: 'clients', id: row[attr] })}>
              <span className='glyphicon glyphicon-share-alt' />&nbsp;{text}
            </a>
          )
          return <OptionsField
            attr={attr}
            val={row[attr]}
            options={store.options.get('clients')}
            labelattr='name' valueattr='id'
            Component={DetailLink} />
        },
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<OptionsField
          attr={attr} val={row[attr]}
          options={store.options.get('ContractPaymentsStatus')}
          labelattr='text' valueattr='value' />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => {
          const { withholdingTax } = _taxValuesHelper(store, row, row.withholding_tax_amount)
          const amountToBePaid = row.amount_to_be_paid || 0
          const amountPaidEx = row.amount_paid || 0
          const isAmountPaidEx = row.amount_paid !== undefined && row.amount_paid !== null &&
            row.amount_paid !== '' && row.amount_paid.toString().length > 0
          const wireFee = row.wire_fee || 0
          const amountPaidCalculated = parseFloat(amountPaidEx) + parseFloat(wireFee) + parseFloat(withholdingTax)
          const revenuesCalculatedBool = amountPaidCalculated.toFixed(2) !== parseFloat(amountToBePaid).toFixed(2) &&
            Math.abs(amountPaidCalculated.toFixed(2) - parseFloat(amountToBePaid).toFixed(2)) > constantsAbsVal
          return <span className={(revenuesCalculatedBool && isAmountPaidEx) ? 'text-warning' : ''}>
            {isAmountPaidEx
              ? amountPaidCalculated.toFixed(2)
              : ' '}
          </span>
        },
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => {
          const { withholdingTax, warningWithholdingTax } = _taxValuesHelper(store, row, row[attr])
          return <span className={warningWithholdingTax ? 'text-warning' : ''}>
            {withholdingTax.toFixed(2).toString()}
          </span>
        },
        (attr, row) => (<DateField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => {
          const vat = row.amount_paid_including_vat && row.amount_paid
            ? (parseFloat(row.amount_paid_including_vat || 0) - parseFloat(row.amount_paid || 0))
            : null
          return (row[attr] && row[attr].length > 0
            ? (vat && vat > 0
              ? <span title={store.__('VAT').concat(': ') + vat.toFixed(2)}>{row[attr]}</span>
              : <span title={store.__('No VAT')}>{row[attr]}</span>)
            : '')
        },
        (attr, row) => (row[attr] && row[attr].length > 0
          ? row[attr].replace(/,/g, ', ')
          : ''),
        (attr, row) => (<DateField attr={attr} val={row[attr]} />)

      ]}
      rowId={(row) => (row)}
      EditForm={_PaymentsEditForm}
    />
  )
}
export default PaymentsEdit
